import { PaletteOptions } from "@mui/material";
import { brand, grey, semantic } from "./tokens";

export type ThemeMode = "light" | "dark";

export const getPalette = (mode: ThemeMode): PaletteOptions => {
  const isDark = mode === "dark";

  return {
    mode,
    primary: {
      main: brand.tealLight,
      dark: brand.tealDark,
      light: "#4FC3B0",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: brand.green,
      dark: "#1FBE63",
      light: "#7DF5A8",
      contrastText: grey[900],
    },
    success: { main: semantic.success },
    warning: { main: semantic.warning },
    error: { main: semantic.error },
    info: { main: semantic.info },
    grey: grey,
    background: {
      default: isDark ? "#111827" : "#F6F8FA",
      paper: isDark ? "#1A2333" : "#FFFFFF",
    },
    text: {
      primary: isDark ? grey[100] : grey[900],
      secondary: isDark ? grey[400] : grey[600],
    },
    divider: isDark ? "rgba(255,255,255,0.08)" : grey[200],
  };
};
